export enum ButtonType {
  Button = 'button',
  Reset = 'reset',
  Submit = 'submit',
}
